(function () {
        "use strict";

        document.addEventListener("DOMContentLoaded", function () {

          /* ── Aircall max wait time ── */
          var AIRCALL_PROXY_URL = "https://vfga4sjhu2lcxbpii3lftznohi0xnhrs.lambda-url.eu-central-1.on.aws/";

          function getPacificTime() {
            return new Date(new Date().toLocaleString("en-US", { timeZone: "America/Los_Angeles" }));
          }

          function getScheduleStatus() {
            var pt = getPacificTime();
            var day = pt.getDay();
            var timeInMinutes = pt.getHours() * 60 + pt.getMinutes();

            // Weekend or Friday after 4:30 PM
            if (day === 0 || day === 6 || (day === 5 && timeInMinutes >= 990)) {
              return { open: false, message: "Available from Monday 6AM (PST)" };
            }

            // Weekday before 6 AM or after 4:30 PM
            if (timeInMinutes < 360 || timeInMinutes >= 990) {
              return { open: false, message: "Available from 6AM (PST)" };
            }

            return { open: true };
          }

          function updateWaitText(text) {
            document.querySelectorAll(".cs-item__wait").forEach(function (el) {
              el.textContent = text;
            });
          }

          function fetchAircallWaitTime() {
            var schedule = getScheduleStatus();
            var callItems = document.querySelectorAll('a.cs-item[href="tel:9099470015"]');

            if (!schedule.open) {
              updateWaitText(schedule.message);
              callItems.forEach(function (item) {
                item.style.opacity = "0.4";
                item.style.pointerEvents = "none";
              });
              return;
            }

            callItems.forEach(function (item) {
              item.style.opacity = "";
              item.style.pointerEvents = "";
            });

            fetch(AIRCALL_PROXY_URL)
              .then(function (res) { return res.json(); })
              .then(function (data) {
                var text;
                if (data.status === "ok" && data.maxMinutes > 0) {
                  text = "Est. Wait: " + data.maxMinutes + " min";
                } else {
                  text = "Est. Wait: < 1 min";
                }
                updateWaitText(text);
              })
              .catch(function () { /* keep default on error */ });
          }

          fetchAircallWaitTime();
          setInterval(fetchAircallWaitTime, 60 * 1000);

          /* ── Panel helpers ── */

          function getActivePanel(toggleEl) {
            var parent = toggleEl.closest(".nav-item--contact-support");
            if (!parent) return null;
            if (window.innerWidth <= 768) {
              return document.getElementById("cs-panel-mobile");
            }
            return parent.querySelector(".cs-panel--desktop");
          }

          function closeAll() {
            document.querySelectorAll(".cs-toggle").forEach(function (t) {
              t.setAttribute("aria-expanded", "false");
            });
            document.querySelectorAll(".cs-panel").forEach(function (p) {
              p.setAttribute("aria-hidden", "true");
            });
          }

          function isAnyOpen() {
            var open = false;
            document.querySelectorAll(".cs-panel").forEach(function (p) {
              if (p.getAttribute("aria-hidden") === "false") open = true;
            });
            return open;
          }

          function updateToggleText() {
            document.querySelectorAll(".cs-toggle__text").forEach(function (el) {
              if (window.innerWidth <= 768) {
                el.innerHTML = "HELP";
              } else {
                el.innerHTML = "CONTACT<br>&amp; SUPPORT";
              }
            });
          }

          function trackContactClick(method) {
            if (typeof gtag === "function") {
              gtag("event", "contact_click", {
                contact_method: method
              });
            }
          }

          updateToggleText();
          window.addEventListener("resize", updateToggleText);

          // Toggle — delegated
          document.addEventListener("click", function (e) {
            if (e.target.closest(".cs-panel")) return;

            var toggleEl = e.target.closest(".cs-toggle");
            if (!toggleEl) return;
            e.preventDefault();
            var panel = getActivePanel(toggleEl);
            if (!panel) return;
            var isOpen = panel.getAttribute("aria-hidden") === "false";
            if (isOpen) {
              closeAll();
            } else {
              closeAll();
              toggleEl.setAttribute("aria-expanded", "true");
              panel.setAttribute("aria-hidden", "false");
              if (window.innerWidth <= 768) {
                window.scrollTo({ top: 0, behavior: "smooth" });
              }
            }
          });

          // Analytics
          document.addEventListener("click", function (e) {
            var item = e.target.closest(".cs-panel .cs-item");
            if (!item) return;

            if (item.classList.contains("cs-chat-trigger")) {
              trackContactClick("Chat Live");
            } else if (item.getAttribute("href") && item.getAttribute("href").indexOf("sms:") === 0) {
              trackContactClick("Text");
            } else if (item.classList.contains("cs-item--email-link")) {
              trackContactClick("Email");
            } else if (item.getAttribute("href") && item.getAttribute("href").indexOf("tel:") === 0) {
              trackContactClick("Call");
            }
          }, true);

          // Click outside — capture phase (AFTER analytics handler)
          document.addEventListener("click", function (e) {
            if (!isAnyOpen()) return;
            if (e.target.closest(".cs-toggle")) return;
            if (e.target.closest(".cs-panel")) {
              e.stopPropagation();
              return;
            }
            closeAll();
          }, true);

          // ESC
          document.addEventListener("keydown", function (e) {
            if (e.key === "Escape" && isAnyOpen()) {
              closeAll();
            }
          });

          // Close on resize
          window.addEventListener("resize", function () {
            if (isAnyOpen()) closeAll();
          });

          // Close button — delegated
          document.addEventListener("click", function (e) {
            if (!e.target.closest(".cs-panel__close")) return;
            e.preventDefault();
            closeAll();
          }, true);

          // Chat triggers — delegated
          document.addEventListener("click", function (e) {
            if (!e.target.closest(".cs-chat-trigger")) return;
            e.preventDefault();
            closeAll();
          });

          document.addEventListener('click', function (e) {
            const trigger = e.target.closest('.cs-order-status-trigger');
            if (!trigger) return;
            e.preventDefault();
            closeAll();
            const iframe = document.getElementById('botscrew-widget');
            if (!iframe || !iframe.contentWindow) return;
            iframe.contentWindow.postMessage({ type: 'open-widget' }, '*');
          }, true);
        });
      })();